module.exports = __webpack_public_path__ + "static/media/mr.20308621.svg";